import { Injectable, NgZone } from "@angular/core";
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthenticationService } from "./authenticationService";
import { OfflineService } from "./offlineService";
import { StringConstants } from "../_store/stringConstants";
import { DialogServiceService } from "../_app-core/dialogs/dialog-service.service";

@Injectable({
    providedIn: "root",
})
export class CustomHttpInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private offlineService: OfflineService,
        private dialogsService: DialogServiceService
    ) {}

    private skipErrorThrows = ["/app/offer", "dashboard/landingPageSummary","/create?tenantDB=ims", "/get/", "/JSW/api/ticket/upload"];

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const url = request.url;
        const reqBody = request.body;
        const isPOST = request.method === "POST";
        if (isPOST) {
            
            
            // if (
            //     this.authenticationService.currentUserData &&
            //     this.authenticationService.currentUserData.session
            // ) {
            if(this.authenticationService.currentUserData && this.authenticationService.currentUserData.session) {
                reqBody.session = (
                    this.authenticationService.currentUserData || {}
                ).session;      
            }              
                        
            if (url.includes('/JSW/api/ticket/') || url.includes('/saveVendorQuery')|| url.includes('/uploadSupDoc') ) {
                request = request.clone({
                    url,
                    body: reqBody
                });
            } else if (url.includes('/PayEXDCAPI') || !url.includes('login')) {
                const sessionId = localStorage.getItem("sessionId");
                if (sessionId) {
                    request = request.clone({
                        url,
                        body: reqBody,
                        headers: request.headers.set('token', sessionId)
                    });
                } else {
                    request = request.clone({
                        url,
                        body: reqBody
                    });
                }
            } else {
                request = request.clone({
                    url,
                    body: reqBody
                });
            }

            
            // }
            const offlineRes = this.offlineService.getDummyResponse(request);
            if (offlineRes) {
                return of(
                    new HttpResponse({ status: 200, body: offlineRes as any })
                );
            }
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.code === "401") {
                        this.authenticationService.logout();
                    }
                    // this.errorDialogService.openDialog(event);
                    if (event.body) {
                        const res: any = event.body;
                        const isSuccess =
                            (res.status || res.success || res.utr) &&
                            !res.error &&
                            res.status !== "error";
                        const skipThrow =
                            this.skipErrorThrows.find((urlToSkip) => {
                                return event.url.indexOf(urlToSkip) !== -1;
                            }) !== undefined;
                        if (!skipThrow && !isSuccess) {
                            throw new Error(
                                res.error ||
                                    res.msg ||
                                    res.message ||
                                    StringConstants.MESSAGES
                                        .INVALID_SERVICE_RESPONSE
                            );
                        }
                    }
                    const urlIsForView =
                        event.url &&
                        (event.url.indexOf("/error") === -1 ||
                            event.url.indexOf("invoice_data") === -1);
                    if (!event.body && !urlIsForView) {
                        throw new Error(
                            StringConstants.MESSAGES.SERVER_GENERAL_ERROR
                        );
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                console.log(error);
                
                const errorCode = error && error.status;
                if (!navigator.onLine) {
                    this.dialogsService.showServerError("nointernet");
                } else {
                    let data = {
                        message:
                            error && error.error && error.error.reason
                                ? error.error.reason
                                : error.message
                                ? error.message
                                : error,
                        status: error.status,
                        header: "Error",
                    };
                    if (
                        errorCode === 404 ||
                        data.message.indexOf("not found") !== -1
                    ) {
                        this.dialogsService.showErrorModal(
                            StringConstants.MESSAGES.DOC_NOT_FOUND
                        );
                    } else if (
                        data.message.indexOf("Oops! There seems") !== -1 ||
                        data.message.indexOf("Unknown") !== -1
                    ) {
                        this.dialogsService.showServerError("servererror");
                    } else {
                        this.dialogsService.showErrorModal(data.message);
                    }
                }
                return throwError(error);
            })
        );
    }
}
